import {ContentfulCards} from '@github-ui/swp-core/components/contentful/ContentfulCards'
import type {PrimerCards} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerCards'

import {Section} from '../../../../../brand/components/BrandPage'
import type {GenericSectionWithIds} from '../../../../../brand/lib/types/contentful'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function OrganizationSection(props: Props) {
  const {contentfulContent} = props
  const {sectionIntro, content} = contentfulContent.fields

  const cards = content?.find(item => item.sys.contentType.sys.id === 'primerCards') as PrimerCards | undefined

  return (
    <Section introComponent={sectionIntro} withBorder>
      {cards ? <ContentfulCards component={cards} /> : null}
    </Section>
  )
}

try{ OrganizationSection.displayName ||= 'OrganizationSection' } catch {}